const API_BASE = process.env.REACT_APP_API_URL || "";

// AuthContext registers its logout here on mount. Going through a setter rather
// than importing AuthContext avoids a circular import (AuthContext -> api -> AuthContext).
let onUnauthorized = null;

export function setUnauthorizedHandler(fn) {
  onUnauthorized = fn;
}

export class ApiError extends Error {
  constructor(message, status, data) {
    super(message);
    this.status = status;
    this.data = data;
  }
}

export async function apiFetch(path, { method = "GET", body, token } = {}) {
  const headers = {};
  if (body !== undefined) headers["Content-Type"] = "application/json";
  if (token) headers.Authorization = `Bearer ${token}`;

  let res;
  try {
    res = await fetch(`${API_BASE}${path}`, {
      method,
      headers,
      body: body === undefined ? undefined : JSON.stringify(body),
    });
  } catch {
    throw new ApiError("שגיאת תקשורת", 0, null);
  }

  let data = null;
  try {
    data = await res.json();
  } catch {
    // non-JSON response — leave data null and fall through to the status check
  }

  if (res.status === 401 && data?.code === "AUTH_REQUIRED" && onUnauthorized) {
    onUnauthorized();
  }

  if (!res.ok) {
    throw new ApiError(data?.error || "שגיאה", res.status, data);
  }

  return data;
}

export { API_BASE };
